export const FIREBASE_CONFIG= {
  apiKey: "AIzaSyB5SsOKR2GKu7VRyIWfi8tKlMfyyRXhvn8",
  authDomain: "tapod-switch-in.firebaseapp.com",
  databaseURL: "https://tapod-switch-in.firebaseio.com",
  projectId: "tapod-switch-in",
  storageBucket: "tapod-switch-in.appspot.com",
  messagingSenderId: "330317566230",
  appId: "1:330317566230:web:2354428831b759ca248037",
  measurementId: "G-90BV68BG3S"
};